import React from 'react';
import { Svg, Path } from 'react-native-svg';

export const LowInStockIcon = ({ size = '20', color = '#EF432D' }) => (
    <Svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM10 2C14.4183 2 18 5.58172 18 10C18 11.0609 17.7935 12.0736 17.4185 13H2.58152C2.20651 12.0736 2 11.0609 2 10C2 5.58172 5.58172 2 10 2Z"
            fill={color}
        />
    </Svg>
);
